'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_e185b7e9 = {"base-line":"Skeleton_module_baseLine__559094f1","effect":"Skeleton_module_effect__559094f1","inverted":"Skeleton_module_inverted__559094f1","container":"Skeleton_module_container__559094f1","paragraph":"Skeleton_module_paragraph__559094f1 Skeleton_module_baseLine__559094f1","avatar":"Skeleton_module_avatar__559094f1 Skeleton_module_baseLine__559094f1","button":"Skeleton_module_button__559094f1 Skeleton_module_baseLine__559094f1","block":"Skeleton_module_block__559094f1"};
require("../../../assets/cjs/components/Skeleton/src/Avatar~DQvu0Hju.css");

exports.default = modules_e185b7e9;
//# sourceMappingURL=Skeleton.module.less.js.map
